import { render, staticRenderFns } from "./QuickGiftBar.vue?vue&type=template&id=3789b5ca&scoped=true"
import script from "./QuickGiftBar.vue?vue&type=script&lang=js"
export * from "./QuickGiftBar.vue?vue&type=script&lang=js"
import style0 from "./QuickGiftBar.vue?vue&type=style&index=0&id=3789b5ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3789b5ca",
  null
  
)

export default component.exports